<template>
	<div class="login_t">
		<el-menu-item>HSNMS 管理系统</el-menu-item>
		<el-card shadow="always">
			<el-form ref="form" :model="form" label-width="70px"
				style="margin-top: 20px; margin-left: 40px; margin-right: 40px; margin-bottom: 30px;">
				<div style="text-align: center; font-size: 20px; font-weight: 500;">HSNMS 管理中心</div>

				<div style="margin-top: 30px;">
					<el-input placeholder="请输入登陆账户" v-model="form.Username">
						<template slot="prepend">登陆账户</template>
					</el-input>
				</div>

				<div style="margin-top: 30px;">
					<el-input type="password" placeholder="请输入登陆密码" v-model="form.Password">
						<template slot="prepend">登陆密码</template>
					</el-input>
				</div>

				<div style="margin-top: 30px;">
					<el-button style="width: 100%; background: #5a6b7c;"  type="info"  @click="onSubmit">登 陆</el-button>
				</div>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					Username: '',
					Password: '',
				}
			}
		},
		methods: {
			onSubmit() {
				let data = new FormData()
				data.append('Username', this.form.Username)
				data.append('Password', this.form.Password)
				this.$admin.postAPI('v1/login/?', data).then(
					res => {
						if (res.data.code == 200) {
							this.$Message.success("登陆成功！")
							//储存Token
							this.$admin.setUser(this.form.Username)
							this.$admin.setToken(res.data.token)
							//登陆成功！,转跳
							this.$router.push('index')
						}
						console.log(res.data);
					});
			}
		}
	}
</script>

<style>
	.login_t {
		margin-top: 25vh;
		margin-right: auto;
		margin-left: auto;
		max-width: 550px
	}
	.body {
		height: 100vh;
		overflow-x: hidden;
		overflow-y: scroll;
		background: #f9f9f9 url('https://img.hsnms.com/20211112/1636716669.png') bottom no-repeat;
		background-size: 100% auto;
	}
	.el-input__inner {
	    background-color: #f5f7fa;
		}
</style>



// WEBPACK FOOTER //
// src/components/views/admin/login.vue